import React, { Component } from "react";
import "./navigation.css";
import { Form } from "react-bootstrap";
import axios from "../../../axios/axios";
import { message } from "antd";
import LoadingOverlay from "react-loading-overlay";
import { adminConfig } from "../../../utils/adminConfig";

export default class DeleteNavigation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      domain: "",

      tv_menu: [],
      tvi_menu: [],
      menuData: {},
    };
  }

  componentDidMount = () => {
    this.getAllMenu();
  };

  getAllMenu = () => {
    this.setState({ isLoading: true });
    axios
      .get("/get-all-menu", adminConfig())
      .then((res) => {
        this.setState({ isLoading: false });

        let { tv_menu, tvi_menu } = res.data;

        this.setState({ tv_menu, tvi_menu });
      })
      .catch((err) => {
        this.setState({ isLoading: false });

        console.error(err);
        message.error("Something went wrong");
      });
  };

  deleteMenu = (e) => {
    e.preventDefault();

    let { _id, head, next } = this.state.menuData;

    let formData = {
      id: _id,
      head,
      next,
      domain: this.state.domain,
    };

    this.setState({ isLoading: true });

    axios
      .post("/delete-menu", formData, adminConfig())
      .then((res) => {
        if (res.data.status) {
          this.setState({
            domain: "",

            menuData: {},
          });

          this.getAllMenu();
          message.success(res.data.message);
        } else {
          this.setState({ isLoading: false });
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        this.setState({ isLoading: false });

        console.error(err);
        message.error("Something went wrong");
      });
  };

  render() {
    let { domain, tv_menu, tvi_menu } = this.state;
    return (
      <LoadingOverlay spinner active={this.state.isLoading} text="Loading...">
        <div className="right_cont">
          <div className="right_banner_banner_cnt">
            <h2>Delete Menu</h2>

            <Form onSubmit={this.deleteMenu}>
              <div className="menu_parttts">
                <div className="predecessor_menu cmn_name">
                  <Form.Label>Domain Name *</Form.Label>
                  <Form.Control
                    name="domain"
                    onChange={(e) => {
                      this.setState({ domain: e.target.value });
                    }}
                    as="select"
                    required
                    className="select_control"
                    value={domain}
                  >
                    <option value="">Select Domain Name</option>
                    <option value="tvi">Tipvalet Incentives</option>
                    <option value="tv">Tipvalet</option>
                  </Form.Control>
                </div>

                {domain && (
                  <div className="predecessor_menu cmn_name">
                    <Form.Label>Delete Menu Item</Form.Label>
                    <Form.Control
                      as="select"
                      className="select_control"
                      required
                      onChange={(e) => {
                        let { value } = e.target;
                        if (value) {
                          let data = JSON.parse(value);
                          let sub_menu = data.sub_menu.map((res) => {
                            return JSON.parse(res);
                          });
                          data.sub_menu = sub_menu;
                          this.setState({
                            menuData: data,
                          });
                        } else {
                          this.setState({ menuData: {} });
                        }
                        this.setState({ logo: "" });
                      }}
                    >
                      <option value="">Select Menu</option>

                      {domain === "tv" &&
                        tv_menu.map((menu, key) => {
                          return (
                            <option value={JSON.stringify(menu)} key={key}>
                              {menu.menu}
                            </option>
                          );
                        })}

                      {domain === "tvi" &&
                        tvi_menu.map((menu, key) => {
                          return (
                            <option value={JSON.stringify(menu)} key={key}>
                              {menu.menu}
                            </option>
                          );
                        })}
                    </Form.Control>
                  </div>
                )}

                <div className="add_button cmn_name">
                  <button
                    type="submit"
                    className="add_btnns delete_menu btn-danger"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </Form>
          </div>
        </div>
      </LoadingOverlay>
    );
  }
}
